import React from "react";
import styled from "styled-components";

import ImgBanner from "../../../static/images/banner.jpg";

const Image = styled.img`
  margin-top: 3.5rem;
  width: 100%;
  height: auto;
  margin-bottom: 0.5rem;
`;

const Banner = () => {
  return (
    <>
      <Image alt="ErgoSolar ErgoSunMeet" src={ImgBanner} />
    </>
  );
};

export default Banner;
